module.exports = __webpack_public_path__ + "img/cover.1a7188cb.jpg";